import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { delay, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { GridView } from '../interfaces/gridView.type';

@Injectable({
  providedIn: 'root',
})
export class ViewDetectionService {
  gridView = new BehaviorSubject<GridView>('large');

  observer$ = this.observer
    .observe([
      '(max-width: 991px)',
      '(min-width: 992px) and (max-width: 1199px)', // Small desktop
    ])
    .pipe(
      delay(1),
      tap(res => {
        if (res.breakpoints['(max-width: 991px)']) {
          this.gridView.next('medium');
        } else {
          this.gridView.next('large');
        }
      }),
    );

  constructor(readonly observer: BreakpointObserver) {
    this.observer$.subscribe();
  }
}
